module.exports = __webpack_public_path__ + "media/images/pic/groups/school-a644cae02705aed405389fbccbdc05ac.jpg";